import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CategoriasService {

  categorias: AngularFirestoreDocument<any>

  constructor(private afs: AngularFirestore) {
    this.categorias= this.afs.doc('config/pFussNggabwBeSFSioCb');

  }

  getCategorias(){
   return this.categorias.valueChanges();
  }

  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp()
  }

  get() {
    return this.afs.doc<any>(`config/pFussNggabwBeSFSioCb`);
  }

  actualizar(data) {
    return this.get().update(data)
  }


}



// WEBPACK FOOTER //
// ./src/app/core/categorias.service.ts